import React, {FC, useCallback, useState} from 'react'
import { styled } from '@pixel/core/styles'
import AutomationLandingPageHeader from './components/AutomationLandingPageHeader'
import CompanyAutomationsListBase, { AutomationSelectedCallback } from './components/CompanyAutomationsListBase'
import AutomationFormModal from './components/AutomationFormModal'
import LocalizedButton from '../components/LocalizedButton'
import { LocalizedText } from '../contexts/Localization/LocalizationTypes'
import { useAutomationFormDataPrefetch } from './hooks/useAutomationFormDataQuery'
import {AutomationSearchResult} from './types/Automations'
import AutomationViewModal from "./components/AutomationViewModal";
import AutomationStatusAlert from "./components/AutomationStatusAlert";

const AutomationEngineContainer = styled('div')({
})

interface AutomationEngineProps {
}

export const AutomationEngine: FC<AutomationEngineProps> = ({

}) => {
    useAutomationFormDataPrefetch()
    const [modalOpen, setModelOpen] = useState(false)
    const [viewModalOpen, setViewModalOpen] = useState(false)
    const [statusAlertOpen, setStatusAlertOpen] = useState(false)
    const [selectedAutomation, setSelectedAutomation] = useState<AutomationSearchResult>(null)
    const [selectedAutomationId, setSelectedAutomationId] = useState(0);
    const [refetch, setRefetch] = useState(false);

    const handleAutomationSelected: AutomationSelectedCallback = useCallback((automation: any) => {
        if (automation) {
            setViewModalOpen(false)
            setSelectedAutomationId(automation.companyAutomationId);
            setModelOpen(true)
            window.scrollTo({ top: 0 })
        }
    }, [])

    const handleAutomationSelectedView: AutomationSelectedCallback = useCallback((automation: any) => {
        if (automation) {
            setSelectedAutomationId(automation.companyAutomationId);
            setViewModalOpen(true)
            window.scrollTo({ top: 0 })
        }
    }, [])

    const handleNewAutomationSelected = () => {
        setSelectedAutomation(null)
        setModelOpen(true)
        window.scrollTo({ top: 0 })
    }

    const handleAutomationStatusAlert: AutomationSelectedCallback = useCallback((automation: any) => {
        if (automation) {
            setSelectedAutomation(automation)
            setStatusAlertOpen(true)
            window.scrollTo({ top: 0 })
        }
    }, [])

    const fetchData = () => {
        setRefetch(!refetch);
    }

    return (
        <AutomationEngineContainer>
            <AutomationLandingPageHeader>
                <LocalizedButton
                    variant="contained"
                    color="primary"
                    text={LocalizedText.AUTOMATION_CREATE_BUTTON}
                    onClick={handleNewAutomationSelected}
                />
            </AutomationLandingPageHeader>

            <CompanyAutomationsListBase
                onAutomationSelected={handleAutomationSelected}
                viewAutomationSelected={handleAutomationSelectedView}
                changeAutomationStatus={handleAutomationStatusAlert}
                fetchData={() => fetchData()}
                refetch={refetch}
            />

            <AutomationFormModal
                open={modalOpen}
                selectedAutomationId={selectedAutomationId}
                onClose={() => {
                    setModelOpen(false)
                    setSelectedAutomationId(0);
                }}
                fetchData={()=>fetchData()}
            />

            <AutomationViewModal
                open={viewModalOpen}
                selectedAutomationId={selectedAutomationId}
                changeAutomationStatus={handleAutomationStatusAlert}
                onAutomationSelected={handleAutomationSelected}
                onClose={() => {
                    setViewModalOpen(false)
                    setSelectedAutomationId(0)
                }}

            />
            <AutomationStatusAlert
                open={statusAlertOpen}
                selectedAutomation={selectedAutomation}
                onClose={() => setStatusAlertOpen(false)}
                fetchData={() => fetchData()}
            />
        </AutomationEngineContainer>
    )
}

export default AutomationEngine
